import { z } from "zod";

export const AddMemberSchema = z.object({
  first_name: z
    .string()
    .min(3, "Please Enter your Name")
    .regex(/^[a-zA-Z\s]+$/, "Name must only contain alphabets and spaces."),
  middle_name: z.string().optional(),
  last_name: z
    .string()
    .min(2, "Please Enter your Name")
    .regex(/^[a-zA-Z\s]+$/, "Name must only contain alphabets and spaces."),
  phone_no: z
    .string()
    .min(10, "Please Enter your Contact Number.")
    .regex(/^\+?\d{10,10}$/, "Enter a valid Contact Number."),
  email: z.string().email("Enter a valid Email Address"),
  whatsapp_number: z
    .string()
    .regex(/^\+?\d{10,10}$/, "Enter a valid WhatsApp Number."),
  address: z.string().min(5, "Please Enter Your Complete Address"),
  district: z.string(),
  city: z.string(),
  state: z.string(),
  gender: z.string(),
  pin: z
    .string()
    .min(6, "Please Enter Your Pin Code")
    .regex(/^\d{6}$/, "Enter a valid Pin Code."),
});

export const EditMemberSchema = AddMemberSchema.partial();

export type EditMemberFormValues = z.infer<typeof EditMemberSchema>;
